import * as URL from "../url.helper";

import { post } from "../api.helper";

export const callGetCINDetails = data => post(URL.GET_CIN_DETAIL, data);

export const callGetOneScormeResponse = data => post(URL.GET_ONE_SCOREME_RESPONSE, data);
